module.exports = __webpack_public_path__ + "img/csr_swiper_04_02.6f1a40c7.jpg";